module.exports = __webpack_public_path__ + "img/0S6A9851.88158a67.jpg";